import { store } from 'app/redux/store';
import { IUser, TaxFillingStatus } from 'app/services/user';
import { updateKey } from '../create/PrepareQuestionnaire/slice';

export default function autoFillPrepareQuestionnaire(user: IUser) {
  const { tax_filing_status } = user;

  store.dispatch(
    updateKey({
      key: 'spouse',
      value:
        tax_filing_status === TaxFillingStatus.MARRIED_FILLING_JOINTLY
          ? 'yes'
          : 'no',
    }),
  );
}
